import Card from '@material-ui/core/Card'
import { Box } from '@material-ui/core'
import styled, { css } from 'styled-components/macro'
import IconButton from '@material-ui/core/IconButton'
import Button from '@material-ui/core/Button'
import { Close, Delete, Done, Gavel, InsertChartOutlined, Stars, TrendingUp } from '@styled-icons/material-rounded'

export const CardViabilidade = styled(Card)`
  width: 300px;
  height: fit-content;
  border: 1px solid #d9dddb;
`

export const GridCampos = styled.div`
  padding: 16px 0 0 0;
  display: grid;
  flex-direction: column;
  grid-template-columns: repeat(2, 1fr);
  row-gap: 20px;
`

export const Campos = styled.div`
  display: grid;
  grid-template-rows: auto;
  row-gap: 4px;
`

export const NomeViabilidade = styled.h3`
  font-family: 'IBMPlexSans-Extrabold';
  padding-bottom: 16px;
  ${({ theme }) => css`
    color: ${theme.colors.black};
  `}
`

export const DataViabilidadeNomeUsuario = styled.p`
  padding-bottom: 16px;
  ${({ theme }) => css`
    font-family: ${theme.font.family};
    color: ${theme.colors.darkGray};
    font-size: ${theme.font.sizes.xsmall};
  `}
`

export const Label = styled.label`
  ${({ theme }) => css`
    font-size: ${theme.font.sizes.xsmall};
    font-family: ${theme.font.family};
    color: ${theme.colors.gray1};
  `}
`

export const Valor = styled.label`
  font-family: 'IBMPlexSans-Bold';
  ${({ theme }) => css`
    font-size: ${theme.font.sizes.small};
    color: ${theme.colors.black};
  `}
`
export const CardActionsCustomizado = styled.div`
  padding: 10px 5px;
`
export const BoxCustomizada = styled(Box)`
  margin: 8px;
  position: relative;
  display: flex;
  justify-content: space-between;
`
export const ButtonCustomizado = styled(Button)`
  border-radius: 4px !important;
`

export const IconButtonCustomizado = styled(IconButton)`
  color: #079d56 !important;
  border: 1px solid #079d56 !important;
  padding: 5px 12px !important;
  border-radius: 4px !important;
`
export const IconButtonCustomizadoLeft = styled(IconButtonCustomizado)`
  left: 10px;
`

export const CabecalhoCard = styled.div`
  height: auto;
`

export const CabecalhoRibbon = styled.div`
  height: 12px;
`

export const TituloCabecalho = styled.div`
  height: 34px;
  line-height: 16px;
  text-transform: uppercase;
  padding: 9px 16px;
  ${({ theme }) => css`
    font-family: ${theme.font.family};
    font-size: ${theme.font.sizes.xsmall};
    font-weight: ${theme.font.bold};
  `}
`
//Rascunho
export const CabecalhoRibbonRascunho = styled(CabecalhoRibbon)`
  ${({ theme }) => css`
    background: ${theme.colors.gray4};
  `}
`
export const TituloCabecalhoRascunho = styled(TituloCabecalho)`
  ${({ theme }) => css`
    color: ${theme.colors.gray};
    background: ${theme.colors.gray6};
  `}
`

//Em Análise
export const CabecalhoRibbonEmAnalise = styled(CabecalhoRibbon)`
  ${({ theme }) => css`
    background: ${theme.colors.blue};
  `}
`
export const TituloCabecalhoEmAnalise = styled(TituloCabecalho)`
  ${({ theme }) => css`
    background: ${theme.colors.blue2};
    color: ${theme.colors.blue3};
  `}
`
export const IconEmAnalise = styled(InsertChartOutlined)`
  width: 20px;
  margin-right: 9px;
  margin-top: -2px;
`

//Aprovado
export const CabecalhoRibbonAprovado = styled(CabecalhoRibbon)`
  ${({ theme }) => css`
    background: ${theme.colors.secondary};
  `}
`
export const TituloCabecalhoAprovado = styled(TituloCabecalho)`
  ${({ theme }) => css`
    background: ${theme.colors.lightGreen};
    color: ${theme.colors.primary};
  `}
`
export const IconAprovado = styled(Done)`
  width: 20px;
  margin-right: 9px;
  margin-top: -2px;
`

//Reprovado
export const CabecalhoRibbonReprovado = styled(CabecalhoRibbon)`
  ${({ theme }) => css`
    background: ${theme.colors.red4};
  `}
`
export const TituloCabecalhoReprovado = styled(TituloCabecalho)`
  ${({ theme }) => css`
    background: ${theme.colors.red3};
    color: ${theme.colors.red2};
  `}
`
export const IconReprovado = styled(Close)`
  width: 20px;
  margin-right: 9px;
  margin-top: -2px;
`

//Simulado
export const CabecalhoRibbonSimulado = styled(CabecalhoRibbon)`
  ${({ theme }) => css`
    background: ${theme.colors.secondary2};
  `}
`
export const TituloCabecalhoSimulado = styled(TituloCabecalho)`
  ${({ theme }) => css`
    color: ${theme.colors.orange2};
    background: ${theme.colors.orange1};
  `}
`
export const IconSimulado = styled(TrendingUp)`
  width: 20px;
  margin-right: 9px;
  margin-top: -2px;
`

//Vigente
export const CabecalhoRibbonVigente = styled(CabecalhoRibbon)`
  ${({ theme }) => css`
    background: ${theme.colors.primary};
  `}
`
export const TituloCabecalhoVigente = styled(TituloCabecalho)`
  ${({ theme }) => css`
    color: ${theme.colors.primary};
    background: ${theme.colors.lightGreen};
  `}
`
export const IconVigente = styled(Stars)`
  width: 20px;
  margin-right: 9px;
  margin-top: -2px;
`

//Oficial
export const CabecalhoRibbonOficial = styled(CabecalhoRibbon)`
  ${({ theme }) => css`
    background: ${theme.colors.blue3};
  `}
`
export const TituloCabecalhoOficial = styled(TituloCabecalho)`
  ${({ theme }) => css`
    color: ${theme.colors.blue3};
    background: ${theme.colors.blue2};
  `}
`
export const IconOficial = styled(Gavel)`
  width: 20px;
  margin-right: 9px;
  margin-top: -2px;
`

//Descartado
export const CabecalhoRibbonDescartado = styled(CabecalhoRibbon)`
  ${({ theme }) => css`
    background: ${theme.colors.red2};
  `}
`
export const TituloCabecalhoDescartado = styled(TituloCabecalho)`
  ${({ theme }) => css`
    color: ${theme.colors.red2};
    background: ${theme.colors.red3};
  `}
`
export const IconDescartado = styled(Delete)`
  width: 20px;
  margin-right: 9px;
  margin-top: -2px;
`

export const TextoModalExcluir = styled.span`
  ${({ theme }) => css`
    color: ${theme.colors.black};
    margin-top: 20px;
    text-align: center;
    line-height: 22px;
  `}
`

export const Linha = styled.div`
  width: 100%;
`

export const IconModalExcluir = styled(Delete)`
  width: 38px;
  ${({ theme }) => css`
    color: ${theme.colors.gray4};
  `}
`
